export default function genererRegroupementProduit() {
  return {
    code: null,
    libelle: null,
    objectifsVente: [],
    commissionsVendeur: [],
    reglesAchat: [],
    cgvs: [],
    actif: true,
    assistantId: null,
    marcheId: null,
    regleFacturationId: null,
    produitsId: [],
    produits: [],
  };
}
